/// <reference types="@types/googlemaps" />
import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	NgZone,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import {Utilities} from '../../utilities/utilities.model';

import {FormControl, Validators} from '@angular/forms';
import {MapsAPILoader} from '@agm/core';
import {DeliveryType, HeadquartersAddress, Place} from '../../../appointments/models/appointment.model';
import {PermissionService} from '@shared/service/permission.service';
import {ROOT_CONTRACT_CLOSING} from 'app/app-routing-roots';
import {MatDialog, MatDialogRef} from '@angular/material';
import {CcDkEditAddressDialogComponent} from '@cc-dekra/components/cc-dk-make-appointment/ccdkedit-address-dialog/cc-dk-edit-address-dialog.component';
import {Observable, of, Subscription} from 'rxjs';
import {EsbContractModel, OfficeAddressModel, OfficeDerogationType} from '@cc-commons/models/esb-contract.model';
import {CommodityModel} from '@shared/models/commodity.model';
import {debounceTime, distinctUntilChanged, takeWhile, tap} from 'rxjs/operators';
import {PermissionFilterModel} from '@shared/models/permission-filter.model';
import {MatOptionSelectionChange} from '@angular/material/core';
import { TranslateContext } from '@shared/pipes/translate.pipe';
import { CostDetailPoService } from '@cc-ald-operator/services/cost-detail-po.service';

export interface Range {
    label: string;
    value: number;
}

@Component({
    selector: 'amd-cc-select-center-for-appointment',
    templateUrl: './cc-select-center-for-appointment.component.html',
    styleUrls: ['./cc-select-center-for-appointment.component.scss']
})
export class CcSelectCenterForAppointmentComponent implements OnInit, OnChanges, OnDestroy {
    @Input() accordionDisabled = false;
    @Input() accordionExpanded = false;
    @Input() resetCenterSelected: boolean;
    @Input() canLoad: boolean;
    @Input() placeDelivery: Place;
    @Input() redeliveryToHeadofficeContract?: EsbContractModel;
    @Input() redeliveryToHeadoffice: boolean;
    @Input() deliveryToHeadofficeType: string;
    @Input() showSelectedCenter: boolean = true;//Permette o meno la visibilità della sezione di riepilogo del centro
    @Input() showOnlyCenterWithCCA: boolean = false;//Filtra i centri selezionabili sono se questi hanno ald_supplied_id valorizzato
    @Output() centerSelectEventEmitter: EventEmitter<Place> = new EventEmitter<Place>();
    @Output() accordionExpandedEventEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() unsetCanLoadEventEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() pickUpOfficeAddressEmitter: EventEmitter<HeadquartersAddress> = new EventEmitter<HeadquartersAddress>();
    @ViewChild('searchAddress') searchAddress: ElementRef;

    address: string;
    responseAddressValid = true;
    places: Place[];
    placeSelected: any;
    dialogSubscription: Subscription;
    searchControl: FormControl;
    rangeControl: FormControl;
    place: google.maps.LatLng;
    autocomplete: any;
    formIsValid = false;
    rangeValues: Range[] = [
        { label: '25km',   value: 25000   },
        { label: '50km',   value: 50000   },
        { label: '100km',  value: 100000  },
        { label: '200km',  value: 200000  },
        { label: '500km',  value: 500000  },
        { label: '1000km', value: 1000000 },
        { label: '1500km', value: 1500000 },
        { label: '2000km', value: 2000000 },
    ];
    rangeSelected = this.rangeValues[0].value;
    searchByName = 'byName';
    searchByAddress = 'byAddress';
    // modelAutoComplete: string;
    // listFormAutoComplete: AutoCompleteItemModel[];
    commoditySelected: CommodityModel;
    searchCenterType: string;

    commodityControl: FormControl = new FormControl(undefined, Validators.minLength(3));
    filteredOptions: Observable<CommodityModel[]>;
    showLoader = false;
    showSearchLoader = false;
    pickUpOfficeAddress: HeadquartersAddress;
    geocoder: google.maps.Geocoder;
    pickUpAtOfficeType: typeof OfficeDerogationType = OfficeDerogationType;
	translateContext = TranslateContext;
    deliveryType: typeof DeliveryType = DeliveryType;
    codAxusAllowedList: string[] = [];

    constructor(
        private mapsAPILoader: MapsAPILoader,
        public permissionService: PermissionService,
        private ngZone: NgZone,
		private costDetailPoService: CostDetailPoService,
        public dialog: MatDialog
    ) {
        
        this.costDetailPoService.getBaseCostPoList({ home_closing: true }).subscribe(res => {

            this.codAxusAllowedList = Array.from( new Set( res.map(x => x.supplier).filter(x => x) ) );
        });
    }

    ngOnInit() {
        this.setAutocompleteCommodities();
        this.placeSelected = this.placeDelivery;
        this.searchControl = new FormControl('', [Validators.required]);
        this.rangeControl = new FormControl();
        this.searchCenterType = this.searchByAddress;
        this.unsetCanLoadEventEmitter.emit();
        this.mapsAPILoader.load().then(() => {
            this.autocomplete = new google.maps.places.Autocomplete(
                this.searchAddress.nativeElement,
                {}
            );
            this.geocoder = new google.maps.Geocoder();
            this.autocomplete.setComponentRestrictions({country: 'it'});

            this.autocomplete.addListener('place_changed', () => {
                this.ngZone.run(() => {
                    if (
                        !Utilities.isVoid(this.autocomplete.getPlace()) &&
                        !Utilities.isVoid(
                            this.autocomplete.getPlace().geometry
                        ) &&
                        !Utilities.isVoid(
                            this.autocomplete.getPlace().geometry.location
                        )
                    ) {
                        this.place = this.autocomplete.getPlace().geometry.location;
                    } else {
                        this.place = null;
                    }
                    if (this.place === undefined || this.place === null) {
                        this.searchControl.setErrors({ErrorSearch: true});
                        this.formIsValid = false;
                        this.places = [];
                        return;
                    } else {
                        this.searchAddress.nativeElement.blur();
                        this.formIsValid = true;
                    }
                });
            });
        });
    }

    ngOnDestroy(): void {
        if (this.dialogSubscription) {
            this.dialogSubscription.unsubscribe();
        }
    }

    autoCompleteChangedField(event: any) {
        if (!Utilities.isVoid(event.value)) {
            this.commoditySelected = event.value;
        } else {
            this.commoditySelected = null;
        }
    }

    setAutocompleteCommodities() {
        /*this.modelAutoComplete = '';
        this.permissionService
            .getCommodities(null)
            .subscribe(commodities => {
                if (!Utilities.isVoid(commodities) && commodities.length > 0) {
                    this.listFormAutoComplete = commodities.filter(commodity => commodity.flag_return_point === true)
                        .map(commodity => {
                            return {
                                value: commodity.ald_commodity_id,
                                labels: {it: commodity.ald_commodity_id + ' - ' + commodity.name + ' - ' + commodity.address}
                            }
                        });
                } else {
                    this.listFormAutoComplete = [];
                }
            });*/
        this.commodityControl.valueChanges
            .pipe(
                distinctUntilChanged(),
                debounceTime(1000)
            ).subscribe(value => {
            if (this.commodityControl.valid && !Utilities.isVoid(value) && value !== '' && typeof value === 'string') {
                this.commoditySelected = null;
                this.showLoader = true;
                this.commodityControl.disable();
                this.filteredOptions = this.permissionService.getCommodities(new PermissionFilterModel({name: value, flag_return_point: true, status: 1}), true).pipe(
                    takeWhile(() => !Utilities.isVoid(value) && value !== '' && typeof value === 'string'),
                    tap((commodities: CommodityModel[]) => {
                        this.showLoader = false;
                        this.commodityControl.enable();
                        if (!commodities || (commodities && commodities.length === 0)) {
                            this.commodityControl.setErrors({'notFound': true});
                        }
                    })
                );
            } else {
                this.filteredOptions = of([]);
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!Utilities.isVoid(changes.resetCenterSelected)) {
            this.resetCenterSelected = changes.resetCenterSelected.currentValue;
            if (this.resetCenterSelected) {
                this.activateCenter(null);
            }
        }
        if (this.canLoad) {
            this.searchControl.reset();
            this.searchAddress.nativeElement.value = '';
            this.address = null;
            this.place = null;
            this.places = null;
            this.redeliveryToHeadofficeContract = null;
            this.unsetCanLoadEventEmitter.emit();
        }
        if (changes.redeliveryToHeadoffice && changes.redeliveryToHeadoffice.currentValue) {
            this.onValidateInputAddress()
        }
        
        if (
            changes.redeliveryToHeadoffice && changes.redeliveryToHeadoffice.currentValue ||
            changes.deliveryToHeadofficeType && changes.deliveryToHeadofficeType.currentValue
            ) {
            this.places = null;
        }
    }

    findCenters(rangeInput?: number) {

        const handler = (commodities: CommodityModel[]): void => {

            if (Utilities.isEmpty(commodities) || !commodities.length) {
                this.places = [];
                this.showSearchLoader = false;
                return;
            }
            
            if (this.deliveryToHeadofficeType === this.deliveryType.HOME_CLOSING) {
                
                // Filtra per CodAxus
                if (!Utilities.isEmpty(this.codAxusAllowedList) && this.codAxusAllowedList.length) {
                    commodities = commodities.filter(x => this.codAxusAllowedList.includes(x.cod_axus.toString()));
                }
            }
            
            this.places = commodities.map(center => this.getPlaceFromCommodity(center));
            this.filterForCCA();
            this.showSearchLoader = false;
        };

        if (this.searchCenterType === this.searchByAddress) {
            this.showSearchLoader = true;
            if (!Utilities.isVoid(this.place)) {
                const lng: string = this.place.toJSON().lng.toFixed(2);
                const lat: string = this.place.toJSON().lat.toFixed(2);
                if (!Utilities.isVoid(lat) && !Utilities.isVoid(lng)) {

                    this.permissionService.getCommoditiesByAddress(lat, lng, this.rangeSelected, ROOT_CONTRACT_CLOSING).subscribe(commodities => {
                        handler(commodities);
                    });
                }
            }
        } else if (this.searchCenterType === this.searchByName) {
            this.showSearchLoader = true;
            const filter = new PermissionFilterModel({
                ald_commodity_id: this.commoditySelected.ald_commodity_id,
                range: this.rangeSelected,
            });
            this.permissionService.getCommodities(filter, true).subscribe(commodities => {
                handler(commodities);
            });
        }
    }

    private filterForCCA(){
        if(this.showOnlyCenterWithCCA){
            this.places = this.places.filter( place => !Utilities.isEmpty(place.ald_supplier_id))
            this.filterForSelected();//Escludo il centro già selezionato
        }
    }

    private filterForSelected(){
        if(this.showOnlyCenterWithCCA){
            this.places = this.places.filter( place => place.ald_supplier_id != this.placeSelected.ald_supplier_id)
        }
    }

    onEditAddressToHeadoffice() {
        const dialogRef: MatDialogRef<CcDkEditAddressDialogComponent> = this.dialog.open(CcDkEditAddressDialogComponent, {
            height: 'auto',
            width: 'auto',
            backdropClass: 'amd-dialog__backdrop--dark',
            panelClass: 'amd-full-screen-simple-table-dialog',
            disableClose: true
        });

        this.dialogSubscription = dialogRef.afterClosed().subscribe((
            data: { address: google.maps.places.PlaceResult, place: google.maps.LatLng }) => {
            if (data && data.place && data.address) {
                this.place = data.place;
                this.address = data.address.formatted_address;
                this.pickUpOfficeAddress = this.buildPickUpOfficeAddress(data.address);
                this.pickUpOfficeAddressEmitter.emit(this.pickUpOfficeAddress);
                this.responseAddressValid = true;
                // this.findCenters(1000000);
            }
        });
    }

    activateCenter(place: any) {
        this.placeSelected = place;
        if (!Utilities.isVoid(this.placeSelected)) {
            this.centerSelectEventEmitter.emit(this.placeSelected);
        }
    }

	displayCenter(center: CommodityModel): string {
		return center ? center.ald_commodity_id + ' - ' + center.name + ' - ' + center.address : '';
	}

	selectCenter(_event: MatOptionSelectionChange): void {
		if (_event.source.selected) {
			this.commoditySelected = _event.source.value;
		}
	}

    getPlaceFromCommodity(center: CommodityModel): Place {
	    const place: Place = new Place();
	    place.place_id = center.id;
	    place.address = center.address;
	    place.name = center.name;
	    place.contact_phone = center.phone;
	    place.has_dedicated_expert = center.flag_dedicated_expert;
	    place.type = Place.TYPE_SERVICE_POINT;
	    place.ald_commodity_id = center.ald_commodity_id;
	    place.ald_supplier_code = center.ald_supplier_code;
        place.ald_supplier_id = center.ald_supplier_id;
	    place.zip_code = center.zip_code;
	    place.municipality = center.municipality;
	    place.address_number = center.address_number;
	    place.province = center.province_code;
	    place.region = center.region;
	    place.lat = center.lat;
	    place.lng = center.lng;
		place.flag_premium_point=center.flag_premium_point;
		place.flag_service_box=center.flag_service_box;
		place.type_description=center.type_description;
		place.flag_return_point=center.flag_return_point;
		place.flag_delivery_point=center.flag_delivery_point;
		place.flag_dedicated_expert=center.flag_dedicated_expert;
		place.flag_base_ald=center.flag_base_ald;
		place.flag_mobstore=center.flag_mobstore;
		place.flag_2w=center.flag_2w;




        if (!Utilities.isVoid(center.distance)) {
            place.distance =
                Math.floor(center.distance) / 1000;
        }
        return place;
    }

	onPageChange(event: any) {
		console.log(event);
	}

    onBuildFormattedAddress(addressInfo: OfficeAddressModel): string {
        if (addressInfo) {
            return addressInfo.street + ' ' + addressInfo.street_nr + ' ' + addressInfo.zip + ' ' + addressInfo.city + ' ' + addressInfo.province + ' ' + addressInfo.state + ' ' + addressInfo.cod_iso_state;
        }
        return '';
    }

    onValidateAddressFromResponse(addressInfo: OfficeAddressModel): boolean {
        return !!addressInfo.street && !!addressInfo.city && !!addressInfo.province && !!addressInfo.cod_iso_state && !!addressInfo.zip;
    }

	buildPickUpOfficeAddress(address: any): Place {
		const address_components: google.maps.GeocoderAddressComponent[] = address.address_components;
		const place: Place = new Place();
		place.place_id = null;
		place.name = null;
		place.type = Place.TYPE_PERSONAL_ADDRESS;
		place.contact_phone = null;
		place.ald_commodity_id = null;
		place.ald_supplier_code = null;
		place.address = address_components.filter(elem => elem.types.includes('route'))[0]? address_components.filter(elem => elem.types.includes('route'))[0].long_name : '';
		place.address_number = address_components.filter(elem => elem.types.includes('street_number'))[0]? address_components.filter(elem => elem.types.includes('street_number'))[0].long_name : '';
		place.lat = address.geometry.location.lat().toString();
		place.lng = address.geometry.location.lng().toString();
		place.distance = null;
		place.has_dedicated_expert = null;
		place.zip_code = address_components.filter(elem => elem.types.includes('postal_code'))[0]? address_components.filter(elem => elem.types.includes('postal_code'))[0].long_name : '';
		place.municipality = address_components.filter(elem => elem.types.includes('administrative_area_level_3'))[0]? address_components.filter(elem => elem.types.includes('administrative_area_level_3'))[0].long_name : '';
		place.province = address_components.filter(elem => elem.types.includes('administrative_area_level_2'))[0]? address_components.filter(elem => elem.types.includes('administrative_area_level_2'))[0].short_name : '';
		place.region = address_components.filter(elem => elem.types.includes('administrative_area_level_1'))[0]? address_components.filter(elem => elem.types.includes('administrative_area_level_1'))[0].long_name : '';
		place.state = address_components.filter(elem => elem.types.includes('country'))[0]? address_components.filter(elem => elem.types.includes('country'))[0].long_name : '';
		return place;
	}

    onValidateInputAddress(): void {
        const addressInfo: OfficeAddressModel = this.redeliveryToHeadofficeContract.pick_up_office_address;

        /**if (!this.onValidateAddressFromResponse(addressInfo)) {
            this.responseAddressValid = false;
            return;
        }*/
        const address = this.onBuildFormattedAddress(addressInfo);
        this.geocoder.geocode({
            address: address
        }, (results, status) => {
            if (status !== google.maps.GeocoderStatus.OK) {
                this.responseAddressValid = false;
                return;
            }
            if ((results.length === 0 || Utilities.isVoid(results))) {
                this.responseAddressValid = false;
            } else {
                this.responseAddressValid = true;
                this.address = results[0].formatted_address;
                this.place = results[0].geometry.location;
                this.pickUpOfficeAddress = this.buildPickUpOfficeAddress(results[0]);
                this.pickUpOfficeAddressEmitter.emit(this.pickUpOfficeAddress);
                this.findCenters();
            }
        })
    }

	getFormattedAddress(place: Place): string {
		return `${place.address ? place.address + ' ' : ''}${place.address_number ? place.address_number + ' ' : ''}${place.municipality ? place.municipality : ''}`;
	}
}
